import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LinkPayload } from '../../interfaces';

@Component({
  selector: 'bevvi-link-payload',
  templateUrl: './link-payload.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkPayloadComponent {
  public readonly payload = input.required<LinkPayload>();
}
